export var PostMessageResponseTypes;
(function (PostMessageResponseTypes) {
    PostMessageResponseTypes["Error"] = "error";
    PostMessageResponseTypes["Message"] = "message";
    PostMessageResponseTypes["ResponseStarted"] = "responseStarted";
})(PostMessageResponseTypes || (PostMessageResponseTypes = {}));
//# sourceMappingURL=postMessageResponseTypes.js.map